import { useCallback } from 'react';
import { ProductFilter } from '../../../../apis/models/products/res/ProductFilter';
import Typo from '../../../../components/atom/Typo';
import FilterItem from './FilterItem';
import strings from '../../../../constants/strings.constants';
import { isEqual } from 'lodash';
import { useSearchParams } from 'react-router-dom';
import { getRecommendProductFilter } from '../../../../utils/utils';
import { Sheet } from 'react-modal-sheet';

export interface FilterBottomSheetProps {
  filters: ProductFilter[];
  visible?: boolean;
  onCancel?: () => void;
  selectedFilter?: ProductFilter;
  onFilterSelected?: (filter?: ProductFilter) => void;
}
function FilterBottomSheet(props: FilterBottomSheetProps) {
  const {
    selectedFilter,
    visible = false,
    onCancel,
    filters,
    onFilterSelected,
  } = props;
  const [searchParams] = useSearchParams();

  const getRecommendProductIds = useCallback(() => {
    try {
      const recommendProductIds = searchParams.get('productIds');
      if (recommendProductIds) {
        return JSON.parse(recommendProductIds) as number[];
      }
      return [];
    } catch (e) {
      return [];
    }
  }, [searchParams]);

  const recommendProductIds = getRecommendProductIds();
  const recommendProductFilter = getRecommendProductFilter(recommendProductIds);

  const isFilterSelected = (filter: ProductFilter) => {
    return isEqual(filter, selectedFilter);
  };

  return (
    <Sheet
      avoidKeyboard={false}
      tweenConfig={{ ease: 'easeOut', duration: 0.4 }}
      isOpen={visible}
      onClose={() => {
        if (onCancel) onCancel();
      }}
    >
      <Sheet.Container>
        <Sheet.Header />
        <Sheet.Content>
          <div className="py-[16px]">
            <div className="flex justify-center mb-4">
              <Typo>{strings.filterCategoriesAndEvents}</Typo>
            </div>
            <div className="flex flex-col">
              <FilterItem
                productFilter={{
                  id: 0,
                  name: strings.all,
                  isEvent: false,
                  isRecommendProduct: false,
                }}
                selected={!selectedFilter}
                onClick={() => {
                  if (onFilterSelected) {
                    onFilterSelected();
                  }
                  if (onCancel) onCancel();
                }}
              />
              {recommendProductIds.length > 0 && (
                <FilterItem
                  productFilter={recommendProductFilter}
                  selected={isFilterSelected(recommendProductFilter)}
                  onClick={() => {
                    if (onFilterSelected) {
                      onFilterSelected(recommendProductFilter);
                    }
                    if (onCancel) onCancel();
                  }}
                />
              )}
              {[...filters].map((filter, index) => (
                <FilterItem
                  productFilter={filter}
                  selected={isFilterSelected(filter)}
                  key={index}
                  onClick={(filter) => {
                    if (onFilterSelected) {
                      onFilterSelected(filter);
                    }
                    if (onCancel) onCancel();
                  }}
                />
              ))}
            </div>
          </div>
        </Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop
        onTap={() => {
          if (onCancel) onCancel();
        }}
      />
    </Sheet>
  );
}

export default FilterBottomSheet;
